/**
 * Gates the whole broker experience. Default off in GrowthBook.
 *
 * Kept here rather than in `config/growthbook`: that registry is imported so
 * widely that touching it re-runs roughly 490 test suites, for one string.
 */
export const BROKER_EXPERIENCE_V2 = 'broker_experience_v2';
